
import FetchMore     from "_components/atoms/fetchMoreLoader";
import VideoCardList from "_components/organisms/videoCardList";

const component = ( {
	data,
	fetchMore,
	isDepleted,
	cardType,
	isLoading
} ) => {

	return (
		<>
			<VideoCardList
				cardType = { cardType }
				list     = { data }
			/>

			<FetchMore
				fetchMore  = { fetchMore }
				isDepleted = { isDepleted }
				isLoading  = { isLoading }
			/>
		</>
	);
};

export default component;